import type { CryptoCurrency, FiatCurrency } from '@0xtorch/core'

type GetAssetParameters = {
  symbol: string
  cryptoCurrencies: readonly CryptoCurrency[]
  fiatCurrencies: readonly FiatCurrency[]
  symbolCryptoIdMap?: Record<string, string>
}

// TODO 取引所独自の symbol を使用している場合の symbol 変換処理を追加
export const getAsset = ({
  symbol,
  cryptoCurrencies,
  fiatCurrencies,
  symbolCryptoIdMap,
}: GetAssetParameters): CryptoCurrency | FiatCurrency | undefined => {
  const upperSymbol = symbol.toUpperCase()
  const idByMap =
    symbolCryptoIdMap === undefined ? undefined : symbolCryptoIdMap[upperSymbol]
  const cryptoByMap =
    idByMap === undefined
      ? undefined
      : cryptoCurrencies.find((crypto) => crypto.id === idByMap)
  if (cryptoByMap !== undefined) {
    return cryptoByMap
  }
  const fiat = fiatCurrencies.find(
    (fiat) => fiat.symbol.toUpperCase() === upperSymbol,
  )
  if (fiat !== undefined) {
    return fiat
  }
  const matchCryptoList = cryptoCurrencies.filter(
    (crypto) => crypto.symbol.toUpperCase() === upperSymbol,
  )
  if (matchCryptoList.length === 0) {
    return undefined
  }
  return matchCryptoList.reduce((previous, current) => {
    if (previous.market?.marketCapUsd === undefined) {
      return current
    }
    if (current.market?.marketCapUsd === undefined) {
      return previous
    }
    return previous.market.marketCapUsd > current.market.marketCapUsd
      ? previous
      : current
  })
}
